import React, { useState } from 'react';
import { Modal, Button } from 'antd';
// import './modal.css';

const ExitModalTest = ({ visible, handleOk, handleCancel }) => {

  return (
    <div className="exitModal">
      {/* <Button type="primary" onClick={showModal}>
        EXIT
      </Button> */}
      <Modal className="exitModal" visible={visible} cancelText={"LEAVE"} okText={"SUBMIT"} onOk={handleOk} onCancel={handleCancel} footer={[
        <Button
          shape="round"
          type="primary"
          style={{ width: 120, backgroundColor: 'white', color: '#636363', borderColor: '#636363' }}
          onClick={handleCancel}

        >
          <div className="bold-600" style={{ fontSize: 12, }}>
            RESUME
          </div>
        </Button>,
        <Button
          shape="round"
          type="primary"
          style={{ width: 120 }}
          onClick={handleOk}
        >
          <div className="bold-600" style={{ fontSize: 12 }}>
            SUBMIT
          </div>
        </Button>
      ]}>

        <h2 className="exit_h1">Do you want to submit the test?</h2>

      </Modal>
    </div>
  )
}

export default ExitModalTest